<template>
  <magic-card :title="$t('servicesystem.common_objects.machine.preventative_maintenance')"
    :icon="'$preventative_maintenance'" :fontsize="'h4'" :editable="true" :externalEditTrigger="dialogtrigger" @modeChange="handleEdit">
    <template v-slot:content>
      <v-list dense class="py-0">
        <switch-li :label="$t('servicesystem.common_objects.machine.service_agreement')"
          :value="Machine.ServiceAgreement">
        </switch-li>
        <date-li v-if="Machine.ServiceAgreement" :label="$t('servicesystem.common_objects.commonterms.next')"
          :value="Machine.ServiceAgreementNextDate" :keyname="'ServiceAgreementNextDate'">
        </date-li>
      </v-list>
      <EditServiceAgreementDialog :externaltrigger="dialogtrigger" :machineId="Machine && Machine.Id"
        :agreement="Agreement">
      </EditServiceAgreementDialog>
    </template>
  </magic-card>
</template>

<script>
import SwitchLi from "@/components/Inputs/SwitchListItem.vue";
import DateLi from "@/components/Inputs/DateListItem.vue";
import MagicCard from "@/views/layouts/SlottedCardSection.vue";
import EditServiceAgreementDialog from "@/components/Dialogs/EditServiceAgreementDialog.vue";

export default {
  name: "MachineForecastingCard",
  props: ["Machine"],
  components: {
    SwitchLi,
    DateLi,
    MagicCard,
    EditServiceAgreementDialog
  },
  mixins: [],

  data() {
    return {
      dialogtrigger: 1,
    };
  },

  methods: {
    handleEdit(mode) {
      console.log("Edit mode changed to: " + mode);
      if (mode === "edit") {
        this.dialogtrigger++;
      }
   
    },
  },

  computed: {
    Agreement() {
      return this.Machine?.MachineServiceAgreement ?? this.Machine.MachineModel?.MachineType?.ServiceAgreement;
    },
  },
};
</script>